<template>
  <div>
    <div style="margin-bottom: 20px">
      <el-button type="danger" icon="el-icon-plus" @click="createdTemplate()">新增模版</el-button>
      <el-button type="danger" icon="el-icon-upload" @click="importDialog=true">导入模版</el-button>
    </div>
    <el-table border class="table" :data="tableData"  height="600px" v-loading="tableQuery.loading">
      <el-table-column property="id" label="ID"></el-table-column>
      <el-table-column property="name" label="模板名称"></el-table-column>
      <el-table-column property="coachName" label="创建老师"></el-table-column>
      <el-table-column property="addTime" label="创建时间"></el-table-column>
      <el-table-column label="操作" width="120" align="center">
        <template #default="scope">
          <el-button type="text" size="small" style="margin-right: 10px" @click.prevent="updateItem(scope.row)">编辑</el-button>
          <el-popconfirm title="确定要删除该班次吗？" @confirm="deleteItem(scope.row.id)">
            <el-button slot="reference" type="text" size="small" style="color: red;margin-right: 10px">删除</el-button>
          </el-popconfirm>
        </template>
      </el-table-column>
    </el-table>

    <el-dialog
        title="新增模板"
        :visible.sync="importDialog"
        width="800px">
      <div style="margin-left: 30px" v-loading="importLoading">
        <el-form label-position="top" :model="importItem" :rules="rules" ref="formRef" label-width="110px" class="demo-ruleForm">
          <el-row>
            <el-col :span="12">
              <el-form-item label-width="100px" label="模板名称" prop="name">
                <el-input style="width: 280px"
                          placeholder="请输入名称"
                          v-model="importItem.name"
                          clearable>
                </el-input>
              </el-form-item>
            </el-col>
            <el-col :span="12">
              <el-form-item label-width="100px" label="可用成员" prop="coachList">
                <el-cascader collapse-tags style="width: 280px" ref="cascaderRef"
                             :options="deptUserTree" v-model="importItem.coachList"
                             :props="{ multiple: true,label:'name',value:'id'}"></el-cascader>
              </el-form-item>
            </el-col>
          </el-row>
          <el-row>
            <el-col :span="11">
              <el-form-item label-width="100px" label="模版文件">
                <el-upload :auto-upload="false" action=" " drag :limit="1" :on-change="changeFile">
                  <i class="el-icon-upload" style="font-size: 44px;margin:20px 0 2px 0"></i>
                  <div class="el-upload__text">将文件拖到此处，或<em>点击上传</em></div>
                </el-upload>
              </el-form-item>
            </el-col>
          </el-row>
        </el-form>

      </div>
      <span slot="footer" class="dialog-footer">
    <el-button @click="importDialog = false">取 消</el-button>
    <el-button type="danger" :disabled="importLoading" @click="importPerformanceTemplate">确 定</el-button>
  </span>
    </el-dialog>
  </div>
</template>

<script>
import {selectPerformanceTemplate, selectPerformanceTemplateDetailsById,
  deletePerformanceTemplateById,importPerformanceTemplate} from "../../../../api/performance/performance";
import {selectDeptAndUserTree} from "../../../../api/contacts/dept";
export default {
  name: "PerformanceTemplate",
  data() {
    const changePeople = (rule, value, callback) => {
      const form = this.importItem;
      if (form.coachList && form.coachList.length>0){
        callback();return
      }
      callback(new Error('请选择可用人员！'));
    };
    return {
      tableQuery:{
        pageIndex:0,
        pageSize:100,
        total:0,
        loading:false
      },
      tableData:[],

      deptUserTree:[],

      importItem:{
        file:null,
        name:"",
        coachList:[]
      },
      rules: {
        name: [{required: true, message: "请输入名称！", trigger: "blur"}],
        coachList: [{ validator: changePeople, trigger: 'blur' }],
        file: [{required: true, message: "请选择文件！", trigger: "blur"}],
      },
      importDialog:false,
      importLoading:false
    }
  },
  methods: {
    createdTemplate(){
      this.$router.push({
        path: "/admin/performance/createdPerformanceTemplate",
      });
    },
    deleteItem(id){
      deletePerformanceTemplateById(id).then(val=>{
        if (val.status) {
          this.selectPage();
          this.$notify({title: '成功', message: '删除模板成功！', type: 'success', offset: 40});
        }
      })
    },
    updateItem(item){
      selectPerformanceTemplateDetailsById(item.id).then(val=>{
        item.list = val.data.list;
        item.coachList = val.data.coachList;
        this.$router.push({
          path: "/admin/performance/updatePerformanceTemplate",
          query: {
            data: {item}
          }
        });
      })
    },
    selectPage(){
      this.tableQuery.loading = true;
      selectPerformanceTemplate(this.tableQuery).then(val=>{
        if (val.status){
          this.tableData = val.data.list;
          this.tableQuery.loading = false;
          this.tableQuery.total = val.data.total;
        }
      })
    },
    /**
     * 处理选择的教练数据
     */
    coachDispose(){
      let list = [];
      const ref = this.$refs.cascaderRef;
      const checkedNodes = ref.getCheckedNodes();
      checkedNodes.forEach((node) => {
        if (node.data.type == 1){//只保留用户不保留部门
          list.push({coachId: node.value,coachName:node.label})
        }
      });
      this.importItem.coachList = list;
    },
    /**
     * 上传问价选中的文件信息
     */
    changeFile(file) {
      console.log(file)
      this.importItem.file = file.raw;
    },
    importPerformanceTemplate(){
      this.$refs.formRef.validate((valid) => {
        if (!valid) {return}
        this.coachDispose();
        this.importLoading = true;
        const formData = new FormData();
        formData.append('name', this.importItem.name);
        formData.append('file', this.importItem.file);
        formData.append('coachListStr', JSON.stringify(this.importItem.coachList));
        importPerformanceTemplate(formData).then(val=>{
          if (val.status){
            this.selectPage();
            this.importDialog = false;
            this.importLoading = false;
            this.$notify({title: '提示', message: '导入模板成功！', type: 'success', offset: 40});
          }else {
            this.$notify.error({title: '导入模板失败！', message: val.data, offset: 40});
          }
        })
      })
    }
  },
  created() {
    this.selectPage();
    selectDeptAndUserTree().then(val=>{
      if (val.status == 200){
        this.deptUserTree=val.data;
      }
    })
  }
}
</script>

<style scoped>
.table{
  width: 100%;
  border-radius: 10px;
  padding: 6px 10px 10px 10px;
  height: 550px;
}
::v-deep .el-upload-dragger {
  width: 280px; /* 调整宽度 */
  height: 130px; /* 调整高度 */
}

</style>

